module.exports = __webpack_public_path__ + "static/media/icn-g.257c43bd.svg";